// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadPackPreview-cls1_2DY","cls2":"DownloadPackPreview-cls2_sjc DownloadPackPreview-cls1_2DY"};